<template>
  <main id="shipment-pallet-receipt-main">
    <account-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" :accountType="shippers" :handling="true"/>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('palletReceipt.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>
      <el-row class="historical-caption-row">
        <el-col>
          <i class="el-icon-info red-armellini"></i>&nbsp;
          <span class="font-gray info-text"> {{ $t('palletReceipt.historical') }} &nbsp;</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="red-link-bold"
            :href="aelis2HistoricalUrl"
          >
            {{ $t('common.here') }}
          </a>
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('palletReceipt.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import constants from '@/utils/constants';
import AccountList from '@/components/AccountList';
import { PALLET_RECEIPT_SEARCH } from '@/store/actions';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';

export default {
  name: 'PalletReceipt',
  components: {
    SearchFilter,
    SearchSummary,
    AccountList
  },
  computed: {
    aelis2HistoricalUrl: () => constants.AELIS2.URLS.PALLET_RECEIPTS
  },
  data() {
    return {
      actionMountChained: ['palletReceipt/setDefaultFilters'],
      actionSelectChained: [PALLET_RECEIPT_SEARCH, 'palletReceipt/getShipperWarehouse'],
      shippers: constants.ACCOUNTS.TYPE[1].value
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
main#shipment-pallet-receipt-main {
  .search-summary-container {
    margin-top: 5px;
  }
}
</style>
